<template>
    <div class="ls-customer-retention-offer-contractors">
        <LsInputLabel label="Choose Pro" :error="errors.has('customerRetentionOfferContractors')" />
        <div
            class="ls-customer-retention-offer-contractors--inputs"
            :class="{
                'ls-customer-retention-offer-contractors--error': errors.has(
                    'customerRetentionOfferContractors'
                ),
            }"
        >
            <label
                v-for="({ id, contractor, contractor_stat, selection },
                idx) in customer_cancellation_retention_offer_contractors"
                :key="id"
                :for="contractor.id"
            >
                <input
                    :id="contractor.id"
                    v-model="localValue"
                    v-validate="idx === 0 ? validation : ''"
                    type="radio"
                    name="customerRetentionOfferContractors"
                    :value="contractor.id"
                    test-id="input"
                />
                <div class="ls-customer-retention-offer-contractors--button">
                    <div>
                        <span class="ls-customer-retention-offer-contractors--name"
                            >{{ contractor.name }} - {{ contractor.user | fullName }}</span
                        >
                        <div class="ls-customer-retention-offer-contractors--stat-row">
                            <LsIcon
                                :color="localValue === contractor.id ? 'white' : 'secondary'"
                                type="star"
                                size="sm"
                            />{{ contractor_stat.rating_sma_t30 }}/5 Avg ratings
                        </div>
                        <div class="ls-customer-retention-offer-contractors--stat-row">
                            <LsIcon
                                :color="localValue === contractor.id ? 'white' : 'secondary'"
                                type="time"
                                size="sm"
                            />{{ contractor_stat.otc48_t30 * 100 }}% jobs completed on time
                        </div>
                    </div>
                    <LsIcon
                        :type="selection"
                        :color="localValue === contractor.id ? 'white' : 'primary'"
                        :size-override="35"
                    />
                </div>
            </label>
        </div>
        <LsInfoCard class="ls-customer-retention-offer-contractors--info-card"
            >This will not distribute any other types of services scheduled for this property to
            this provider. Please cancel those services if the customer does not want those services
            or if they do not want their current provider to return to their property.</LsInfoCard
        >
    </div>
</template>

<script>
import VueTypes from 'vue-types';
import { lsTrackingService } from 'ls-vue-common';
import { LsInfoCard, LsIcon, LsInputLabel } from '@/components/common';

export default {
    name: 'LsCustomerRetentionOfferContractors',
    components: { LsInfoCard, LsIcon, LsInputLabel },
    inject: ['$validator'],
    props: {
        // eslint-disable-next-line vue/prop-name-casing
        customer_cancellation_retention_offer_contractors: VueTypes.arrayOf(
            VueTypes.shape({
                id: VueTypes.string.isRequired,
                selection: VueTypes.oneOf(['ratings', 'otc']).isRequired,
                contractor_stat: VueTypes.shape({
                    rating_sma_t30: VueTypes.number.isRequired,
                    otc48_t30: VueTypes.number.isRequired,
                }).isRequired.loose,
                contractor: VueTypes.shape({
                    id: VueTypes.string.isRequired,
                    name: VueTypes.string.isRequired,
                    user: VueTypes.shape({
                        first_name: VueTypes.string.isRequired,
                        last_name: VueTypes.string.isRequired,
                    }).isRequired.loose,
                }).isRequired.loose,
            }).isRequired.loose
        ).isRequired,
        validation: VueTypes.object.required,
        value: VueTypes.string,
    },
    computed: {
        localValue: {
            get() {
                return this.value;
            },
            set(value) {
                lsTrackingService.track({
                    event: 'click',
                    target: 'cancel_view_retain_customer_step-offer_contractors',
                    data: { value },
                });
                this.$emit('input', value);
            },
        },
    },
};
</script>

<style lang="scss">
.ls-customer-retention-offer-contractors {
    color: $secondary;
    font-size: 1.2rem;
    input {
        display: none;
    }

    input + div {
        border: 1px solid $secondary-light;
        border-radius: 5px;
        padding: 10px;
    }

    input:checked + div {
        background: $primary;
        color: $white;
    }
}

.ls-customer-retention-offer-contractors--error {
    input + div {
        border: 1px solid $danger;
    }
}

.ls-customer-retention-offer-contractors--inputs {
    display: flex;
    > :not(:first-child) {
        padding-left: 10px;
    }
    > :hover {
        opacity: $hover-opacity;
        cursor: pointer;
    }

    @media (max-width: $tablet-max-width) {
        flex-direction: column;
        > :not(:first-child) {
            padding-left: 0;
            padding-top: 10px;
        }
    }
}

.ls-customer-retention-offer-contractors--button {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 355px;
    @media (max-width: $tablet-max-width) {
        width: 330px;
    }
}

.ls-customer-retention-offer-contractors--name {
    font-weight: $semi-bold;
}

.ls-customer-retention-offer-contractors--stat-row {
    display: flex;
    align-items: center;
    margin-top: 5px;
    > svg {
        margin-right: 5px;
    }
}

.ls-customer-retention-offer-contractors--info-card {
    margin-top: 10px;
}
</style>
